import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider, IconButton, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { sxDarkGreyBody, sxDivider, sxSubTitle } from "../../../../../assets/styles/CommonSxProps";
import { ProcedimentoRealizado } from "../../../../../interfaces/entities/Reembolso/ProcedimentoRealizado";
import "./styles.css";
import { sxErrorButton } from "./sxProps";
import { formatStringToReaisNumberFormat } from "../../../../../utils/MoneyFormat";

const ProcedimentoReembolsoCard: React.FC<{
  procedimentoRealizado: ProcedimentoRealizado,
  even: boolean,
  indice: number,
  handleDeleteProced: (indice: number) => void,
}> = ({ procedimentoRealizado, even, indice, handleDeleteProced }) => {

  const formatDate = (date: Dayjs) => date.format('DD/MM/YYYY');

  return (

    <div className={`procedimento-reembolso-card ${even ? 'even' : 'odd'} ${indice === 0 ? 'radius-first-proced' : ''}`}>
      <div>
        <Typography display={"flex"} justifyContent={'space-between'} alignItems={"center"} sx={sxSubTitle}>
          Procedimento
          <IconButton 
            aria-label={`Remover procedimentos ${procedimentoRealizado.procedimento?.descr} ${procedimentoRealizado.especialidade?.descricao || '-'}, realizados em ${procedimentoRealizado.datas.map(data => data.toString()).join(', ')}, no valor total de ${procedimentoRealizado.valorPago}`} 
            sx={sxErrorButton} 
            onClick={() => handleDeleteProced(indice)}
          >
            <FontAwesomeIcon icon={faClose} />
          </IconButton>
        </Typography>
      </div>
      <Typography>{procedimentoRealizado.procedimento?.descr}</Typography>
      <Typography sx={sxSubTitle}>Especialidade</Typography>
      <Typography sx={sxDarkGreyBody}>{procedimentoRealizado.especialidade?.descricao || '-'}</Typography>
      <div className="dates-grid">
        {procedimentoRealizado.datas.map((data, index) => (
          <div key={index}>
            <Typography sx={sxSubTitle}>Data {index + 1}</Typography>
            <Typography key={index} sx={sxDarkGreyBody}>{formatDate(data)}</Typography>
          </div>
        ))}
      </div>
      <Divider sx={sxDivider} />
      <div className="valor-row">
        <Typography sx={sxSubTitle}>Valor</Typography>
        <Typography sx={sxDarkGreyBody}>R$ {formatStringToReaisNumberFormat(procedimentoRealizado.valorPago)}</Typography>
      </div>
    </div>
  )
}

export default ProcedimentoReembolsoCard;